export const mouths = [
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ'
]

export const mouthsPerNumber = (data: Array<number>)  => data.map(i => mouths[i])
